export const BASEURL = process.env.REACT_APP_BASE_URL || 'https://dev-meghmani.nstackapp.com/api';

const token = window.localStorage.getItem('auth-token');
export const headers = {
  'x-auth-token': `${token}`,
};
